<body>
  <app-nav-menu>
  </app-nav-menu>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  <ng-http-loader spinner="sk-chasing-dots"></ng-http-loader>
</body>
